// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"H_-z"};